import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Theme } from '../../utils/theme';
import Text from './Text';

interface ProfileSummaryItemProps {
  icon?: React.ReactNode;
  label: string;
  value: string;
  isName?: boolean;
}

export default function ProfileSummaryItem({ 
  icon, 
  label, 
  value, 
  isName = false 
}: ProfileSummaryItemProps) {
  return (
    <View style={[styles.container, isName && styles.nameContainer]}>
      {icon && (
        <View style={styles.iconContainer}>
          {icon}
        </View>
      )}
      <View style={styles.textContainer}>
        <Text style={styles.label}>
          {label}
        </Text>
        <Text style={styles.value}>
          {value}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: Theme.spacing.sm,
    paddingVertical: Theme.spacing.md,
    paddingHorizontal: Theme.spacing.sm,
    borderRadius: Theme.borderRadius.sm,
    backgroundColor: Theme.colors.background,
    alignItems: 'center',
    alignSelf: 'stretch',
    width: '100%',
  },
  nameContainer: {
    paddingHorizontal: Theme.spacing.xs,
    backgroundColor: 'transparent',
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: Theme.borderRadius.sm,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  label: {
    fontSize: 14,
    lineHeight: 20,
    fontFamily: Theme.typography.fontFamily.regular,
    color: '#8994b8',
    alignSelf: 'stretch',
    textAlign: 'left',
  },
  value: {
    fontSize: 18,
    lineHeight: 26,
    fontFamily: Theme.typography.fontFamily.semiBold,
    color: '#3a4c89',
    alignSelf: 'stretch',
    textAlign: 'left',
  },
}); 